import React, {Fragment, useEffect, useRef, useState} from 'react';

export default function PixelationOverlay({ src, status }) {
  const canvasRef = useRef(null);
  const imgRef = useRef(null);
  const [imgLoaded, setImgLoaded] = useState(false);
  const animationRef = useRef(null);
  const resizeTimeout = useRef(null);

  // Stages: large → small pixels
  const stages = [10, 20, 30, 40, 50, 60, 70, 80];

  useEffect(() => {
    if (!imgLoaded) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const img = imgRef.current;
    let stageIndex = 0;

    function setCanvasSize() {
      if (!canvas || !canvas.parentNode) return;
      const parentRect = canvas.parentNode.getBoundingClientRect();
      canvas.width = parentRect.width;
      canvas.height = parentRect.height;
    }

    setCanvasSize(); // initial size

    const animate = () => {
      if (!img || !ctx) return;

      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);

      ctx.imageSmoothingEnabled = false;
      const scale = stages[stageIndex];

      // Draw pixelated
      ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, scale, scale);
      ctx.drawImage(canvas, 0, 0, scale, scale, 0, 0, w, h);

      stageIndex = (stageIndex + 1) % stages.length;
      animationRef.current = setTimeout(animate, 500);
    };

    animate();

    // Debounced resize handler
    const handleResize = () => {
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        setCanvasSize();
      }, 1000); // debounce: 1 second
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(animationRef.current);
      clearTimeout(resizeTimeout.current);
      window.removeEventListener('resize', handleResize);
    };
  }, [imgLoaded]);

  return (
    <Fragment>
      <img
        ref={imgRef}
        src={src}
        style={{ display: 'none' }}
        onLoad={() => setImgLoaded(true)}
      />
      <canvas
        ref={canvasRef}
        className="pixelation-canvas"
      />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/moodboard_ai_requests/PixelationIverlay.js